import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import Locale from '/b2b/common/components/Locale/Locale.component';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const styles = theme => {
    return {
        formControl: {
            display: 'flex',
            margin: theme.spacing(2, 1, 1),
        },
        popover: {
            zIndex: theme.zIndex.tooltip + 1,
        },
    };
};

const useStyles = makeStyles()(styles);

function handleClose() {
    setTimeout(() => {
        document.activeElement.blur();
    }, 0);
}

const FeatureFlagSelect = props => {
    const { classes } = useStyles();
    const id = 'admin_toggle_feature_flag';
    const { label, menuContainer, onChange, options, value } = props;
    const inputLabel = React.useRef(null);
    const handleChange = event => {
        onChange && onChange(event.target.value);
    };

    return (
        <FormControl
            classes={{
                root: classes.formControl,
            }}
            variant="outlined"
            size="small"
        >
            <InputLabel id={`${id}_label`} ref={inputLabel}>
                <Locale path={label} />
            </InputLabel>
            <Select
                id={id}
                labelId={`${id}_label`}
                onChange={handleChange}
                onClose={handleClose}
                variant="outlined"
                label={<Locale path={label} />}
                multiple
                value={value}
                name="featureFlags"
                MenuProps={{ container: menuContainer, PopoverClasses: { root: classes.popover } }}
            >
                {options.map(({ label, value }) => (
                    <MenuItem key={value} value={value}>
                        {label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

FeatureFlagSelect.propTypes = {
    label: PropTypes.string,
    menuContainer: PropTypes.object,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.string,
        })
    ),
    value: PropTypes.arrayOf(PropTypes.string),
};

export default FeatureFlagSelect;
